module.exports = __webpack_public_path__ + "img/大暴雨.59f27145.png";